import React from "react";
import { createRoot } from "react-dom/client";

import { Provider } from "react-redux";
import { Router } from "react-router-dom";

import history from "./history";
import store from "./store/store";
import setupInterceptors from "./store/services/setupInterceptors";

import reportWebVitals from "./reportWebVitals";

import "./main.css";
import "leaflet/dist/leaflet.css";
import "leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.webpack.css"; // Re-uses images from ~leaflet package
import "leaflet-defaulticon-compatibility";
import "react-leaflet-markercluster/dist/styles.min.css";

import App from "./App";

import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";

const persist = persistStore(store);
setupInterceptors(store);

// React 18 createRoot API
const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persist}>
        <Router history={history}>
          <App />
        </Router>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
